import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { PageContainer } from '@ant-design/pro-layout';
import { Badge } from 'antd';
import { useCountPendingApprovals } from 'hooks';
import Main from '../layout/Main';
import PendingExtensions from './PendingExtensions';
import PendingVirements from './PendingVirements';
import PendingProposalRevisions from './PendingProposalRevisions';
import PendingWithdrawals from './PendingWithdrawals';
import PendingReportSubmissions from './PendingReportSubmissions';
import PendingProjectApplication from './PendingProjectApplication';

const contentList = {
  '#extensions': <PendingExtensions />,
  '#virements': <PendingVirements />,
  '#proposal-revisions': <PendingProposalRevisions />,
  '#withdrawals': <PendingWithdrawals />,
  '#report-submissions': <PendingReportSubmissions />,
  '#project-application': <PendingProjectApplication />,
};

const badge = (count, text) => (
  <Badge
    size="small"
    count={count}
    offset={count < 10 ? [8, 0] : count < 100 ? [14, 0] : [18, 0]}
    className="ant-badge-count-primary"
    // overflowCount={9}
  >
    {text}
  </Badge>
);

const PendingApprovals = () => {
  const history = useHistory();
  const { hash } = useLocation();
  const { count, loading } = useCountPendingApprovals();

  const handleTabChange = (key) => {
    history.push(`/pending-approvals${key}`);
  };

  const getTabKey = () => {
    if (hash && hash !== '') {
      return hash;
    }

    return '#extensions';
  };

  return (
    <Main>
      <PageContainer
        header={{ title: 'Pending Approvals' }}
        ghost
        loading={loading}
        onTabChange={handleTabChange}
        tabActiveKey={getTabKey()}
        tabList={[
          {
            key: '#extensions',
            tab: badge(count.extensions, 'Extensions'),
          },
          {
            key: '#virements',
            tab: badge(count.virements, 'Virements'),
          },
          {
            key: '#proposal-revisions',
            tab: badge(count.proposalRevisions, 'Proposal Revisions'),
          },
          {
            key: '#withdrawals',
            tab: badge(count.withdrawals, 'Withdrawals'),
          },
          {
            key: '#report-submissions',
            tab: badge(count.reportSubmissions, 'Reports'),
          },
          {
            key: '#project-application',
            tab: badge(
              count.projectApplications,
              'Funding Applications Endorsement'
            ),
          },
        ]}
      >
        {contentList[hash]}
      </PageContainer>
    </Main>
  );
};

export default PendingApprovals;
